import { ArrayParam, NumberParam, StringParam } from 'use-query-params'

import { FILTERS_PARAMS_KEYS } from '@app/api/constants'
import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'

import type { QuotaReportDirectoryDataSource } from './types'
import type { ColumnTableSearchSchema, TableSearchQuerySchema } from '@app/hooks/useTableSearch/types'
import type { ColumnTitleSchema } from '@app/types/table'

export const columnTitleMap: ColumnTitleSchema<QuotaReportDirectoryDataSource> = {
  monitoringType: 'Тип мониторинга',
  store: 'ТК Лента',
  cluster: 'Кластер',
  clustersGroup: 'Группа кластеров',
  salesOrganization: 'Сбытовая организация',
  trend: 'Направление',
  trendId: 'Код направления',
  purchasingGroup: 'ГЗ',
  purchasingGroupId: 'Код ГЗ',
  commodityGroup: 'Тов.группа',
  commodityGroupId: 'Код тов. группы',
  category: 'Категория',
  categoryId: 'Код категории',
  subcategory: 'Подкатегория',
  subcategoryId: 'Код подкатегории',
  brandCount: 'Квота Бренд',
  eppCount: 'Квота EPP/ЧТМ'
}

export const topFiltersQuerySchema = {
  [FILTERS_PARAMS_KEYS.monitoringTypeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.storeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.clusterIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.clustersGroupIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.salesOrganizationIds]: ArrayParam
}

export const tableSearchQuerySchema: TableSearchQuerySchema<QuotaReportDirectoryDataSource> = {
  'table-monitoringType': StringParam,
  'table-store': StringParam,
  'table-cluster': StringParam,
  'table-clustersGroup': StringParam,
  'table-salesOrganization': StringParam,
  'table-trend': StringParam,
  'table-trendId': StringParam,
  'table-purchasingGroup': StringParam,
  'table-purchasingGroupId': StringParam,
  'table-commodityGroup': StringParam,
  'table-commodityGroupId': StringParam,
  'table-category': StringParam,
  'table-categoryId': StringParam,
  'table-subcategory': StringParam,
  'table-subcategoryId': StringParam,
  'table-brandCount': NumberParam,
  'table-eppCount': NumberParam
} as const

const titleWrapperProps = { minWidth: 200 } as const

export const columnsSearchSchema: ColumnTableSearchSchema<QuotaReportDirectoryDataSource> = {
  monitoringType: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  store: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  cluster: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  clustersGroup: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  salesOrganization: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  trend: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  trendId: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  purchasingGroup: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  purchasingGroupId: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  commodityGroup: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  commodityGroupId: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  category: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  categoryId: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  subcategory: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  subcategoryId: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  brandCount: { type: columnSearchSchemaOptionType.NUMERIC_INPUT, titleWrapperProps },
  eppCount: { type: columnSearchSchemaOptionType.NUMERIC_INPUT, titleWrapperProps }
}
